module.exports = __webpack_public_path__ + "static/media/white_facebook.e101fccc.svg";